export enum Steps {
  START,
  // Part 1 — "what lane are you in?" (everyone answers these)
  MUSIC_USE,
  ADVERTISEMENT,
  BROADCAST_NETWORK,
  MUSIC_CONTENT,
  LIVESTREAMS,
  // Part 2 — which product (Free users + guests only; subscribers skip these)
  WILLING_TO_PAY,
  GIVE_CREDIT,
  FREQUENCY,
  TRACK_COUNT,
  // Finals (isFinalStep := step >= FINAL_FREE_USE)
  FINAL_FREE_USE,
  FINAL_FREE_NEEDS_CREDIT,
  FINAL_SINGLE_LICENSE,
  FINAL_SUBSCRIPTION,
  FINAL_CUSTOM_LICENSE,
  FINAL_BECOME_CREATOR,
  FINAL_LIVESTREAMS,
}
